import { render, staticRenderFns } from "./treeOrTableSon.vue?vue&type=template&id=7c3f7f14&scoped=true&"
import script from "./treeOrTableSon.vue?vue&type=script&lang=js&"
export * from "./treeOrTableSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f7f14",
  null
  
)

export default component.exports